import { useState } from "react";
import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { getArticlesByCategory, getLatestArticles } from "@/mocks/articles";
import ArticleCard from "@/components/base/ArticleCard";

export default function LatestNews() {
  const [activeCategory, setActiveCategory] = useState<string | null>(null);

  const allCategories = categories;
  const displayArticles = activeCategory
    ? getArticlesByCategory(activeCategory).slice(0, 8)
    : getLatestArticles(8);

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 whitespace-nowrap">
            最新黑料更新
          </h2>
          <div className="flex items-center gap-1.5 overflow-x-auto pb-1 flex-wrap">
            <button
              onClick={() => setActiveCategory(null)}
              className={`whitespace-nowrap px-3 py-1.5 rounded-full text-sm transition-colors duration-200 cursor-pointer ${
                activeCategory === null
                  ? "bg-primary-500 text-white"
                  : "bg-background-100 text-foreground-600 hover:bg-background-200"
              }`}
            >
              全部
            </button>
            {allCategories.map((cat) => (
              <button
                key={cat.id}
                onClick={() => setActiveCategory(cat.slug)}
                className={`whitespace-nowrap px-3 py-1.5 rounded-full text-sm transition-colors duration-200 cursor-pointer ${
                  activeCategory === cat.slug
                    ? "bg-primary-500 text-white"
                    : "bg-background-100 text-foreground-600 hover:bg-background-200"
                }`}
              >
                {cat.name}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {displayArticles.map((article) => (
            <ArticleCard key={article.id} article={article} variant="default" />
          ))}
        </div>

        {activeCategory && displayArticles.length > 0 && (
          <div className="mt-6 text-center">
            <Link
              to={`/category/${activeCategory}`}
              className="inline-flex items-center gap-2 px-6 py-2.5 bg-background-100 text-foreground-700 rounded-full text-sm hover:bg-background-200 transition-colors duration-200 cursor-pointer"
            >
              查看全部{allCategories.find(c => c.slug === activeCategory)?.name || ""}内容
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        )}
      </div>
    </section>
  );
}